import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from '../shared/services/user.service';
import { Credentials } from '../shared/models/credentials.interface';

import { CommonSerivce } from '../shared/services/common.service';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Inject } from '@angular/core';
import { Local } from 'protractor/built/driverProviders';
import { AuthService } from '../shared/services/auth.service'; // Import your AuthService


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  providers: [UserService, CommonSerivce],
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  status: boolean;
  subscription: Subscription;
  loginUser: String = "";
  dataRole: String = "";
  processRole: String = "";
  isLoggedIn: boolean;
  AutoReload: boolean = true;
  showLoginInfo: boolean = false;
  environment: String = "";
  systemVersion: String = "";

  //login variable
  errors: string;
  isRequesting: boolean;
  submitted: boolean = false;

  LoginApiPath: string = "api/BcpJwtAuth/";

  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private router: Router, private userService: UserService, private bcp: CommonSerivce
    , private authService: AuthService  ) {
    this.getSystemEnvironment();
    //20211202 Program Fix Start - Unable to show Environment from Connection string - Jelly
    //this.environment = this.bcp.getEnvironment();
    //20211102 Program Fix End
    //20211202 Enhancement Start - Change Display Enviropnment to Connected Database in Header - Jelly
    this.getSystemDatabase();
    //20211202 Enhancement End
  }


  ngOnInit() {
    // this.subscription = this.userService.authNavStatus$.subscribe(status => this.status = status);
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();

  }

  logout() {
    console.log("Logout in header");
    this.errors = null;
    this.http.post(this.LoginApiPath + "logout",
      {}, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).subscribe((result: any) => {
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('auth_token_long');
      sessionStorage.setItem('isLoggedIn', "false");
      sessionStorage.setItem('currentDomain', "");
      sessionStorage.setItem('currentUser', "");
      sessionStorage.setItem('currentProcessRole', "");
      sessionStorage.setItem('currentDataRole', "");
      sessionStorage.setItem('environment', "")
      sessionStorage.setItem('database', "")

      this.authService.logout();
    }, (error) => {
      let e1: any[];
      this.errors = JSON.parse(JSON.stringify(error.error))["logout_result"];
    });
  }


  getSystemEnvironment() {
    var parseResult: any = {};
    this.http.get(this.LoginApiPath + "getEnvironment", {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
      .subscribe((result: any) => {
        parseResult = JSON.parse(result);
        sessionStorage.setItem('environment', JSON.stringify(parseResult.environment));
        sessionStorage.setItem('systemVersion', JSON.stringify(parseResult.systemVersion));
        //20211202 Program Fix Start - Unable to show Environment from Connection string - Jelly
        this.environment = JSON.parse(sessionStorage.getItem('environment'));
        //20211202 Program fix End
      }, (error) => {
      });
  }

  //20211202 Enhancement Start - Change Display Enviropnment to Connected Database in Header - Jelly
  getSystemDatabase() {
    var parseResult: any = {};
    this.http.get(this.LoginApiPath + "getDatabase", {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
      .subscribe((result: any) => {
        parseResult = JSON.parse(result);
        sessionStorage.setItem('database', JSON.stringify(parseResult));

        //this.environment = JSON.parse(sessionStorage.getItem('database'));
      }, (error) => {
      });

  }
  //20211202 Enhancement end

}
